import { render, staticRenderFns } from "./tempCard.vue?vue&type=template&id=3d04e4d0&"
import script from "./tempCard.vue?vue&type=script&lang=js&"
export * from "./tempCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports